import React from 'react';
import { focusRing } from '../../Themes/base/focusRing';
import {
	InputEpoCustoms,
	InputBaseFontStyle,
	InputBaseStyle,
	IconBeforeInputStyles,
	InputDisabledStyle,
	ForceRemoveBorders,
	IconAfterInputStyles,
	InputSpacing,
	InputColorStyle,
} from '../Input/styles';
import { IDummyProps } from '../Input/types';

import * as meta from '../../meta-data.json';
import { CloseIconComponent } from '../../Utilities/utils/Theming';

export const overridesInput = (props: IDummyProps, dataProps: any, dataAria: any, noDataAriaProps: any) => {
	const {
		clearOnEscape,
		autoComplete,
		autoFocus,
		inputRef,
		className,
		warning,
		size = 'default',
		...rest
	} = noDataAriaProps;
	delete rest['root-props'];
	delete rest['input-props'];

	return {
		Root: {
			style: ({ $theme, $isFocused, $error, $positive }: any) => {
				return {
					...InputBaseFontStyle($theme, props),
					...InputBaseStyle($theme, props, $isFocused),
					...InputEpoCustoms($theme, $isFocused, $error, $positive, false, props),
					...InputEpoCustoms($theme, $isFocused, $error, $positive, warning || false, props),
					height: `var(--epods--input-${size}-height)`,
				};
			},
			props: {
				'data-epo': `epo-input-${meta.version}`,
				part: `epo-input-${meta.version}`,
				'data-testid': 'epo-phone-input-root',
			},
		},
		InputContainer: {
			style: () => {
				return {
					...ForceRemoveBorders,
					backgroundColor: 'transparent',
				};
			},
		},
		Input: {
			style: ({ $theme }: any) => {
				return {
					...InputBaseFontStyle($theme, props),
					...InputSpacing($theme, props),
					...InputDisabledStyle($theme, props),
					...InputColorStyle($theme, props),
					backgroundColor: 'transparent',
					color: 'var(--epods--color-text-primary)',
					height: `var(--epods--input-${size}-height)`,
				};
			},
		},
		ClearIcon: {
			component: ({
				$isFocused,
				$isFocusVisible,
				$disabled,
				$size,
				$error,
				$positive,
				$required,
				$adjoined,
				...args
			}: any) => (
				<CloseIconComponent tooltipContent="Clear" data-testid="epods-clear-icon-phone-input" {...args} />
			),
		},
		MaskToggleButton: {
			style: () => {
				return {
					':focus': focusRing,
				};
			},
		},
		ClearIconContainer: {
			style: () => {
				return {
					paddingRight: props.iconAfter ? '0' : '12px', // Trick to hide the original icon
				};
			},
		},
		EndEnhancer: {
			style: ({ $theme }: any) => {
				return {
					...IconAfterInputStyles($theme),
					backgroundColor: 'transparent',
				};
			},
		},
		StartEnhancer: {
			style: ({ $theme }: any) => {
				return {
					...IconBeforeInputStyles($theme),
					backgroundColor: 'transparent',
				};
			},
		},
	};
};
